<!--
 * @Author: DQL
 * @Date: 2020-03-18 10:31:17
 * @LastEditors: zxf
 * @LastEditTime: 2023-05-31 15:13:20
 * @Description: 机构管理--查看机构信息
 -->
<template>
  <el-form
    ref="fd"
    class="c-form"
    :model="fd"
    :inline="true"
    label-position="right"
    label-width="140px"
    label-suffix="："
  >
    <el-row class="c-form__row">
      <el-col
        class="c-form__col"
        :span="24"
      >
        <el-form-item
          class="c-form__item"
          label="企业名称"
          prop="deptName"
        >
          <span class="c-form__read">
            {{ fd.deptName }}
          </span>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="24"
      >
        <el-form-item
          class="c-form__item"
          label="所属区域"
          prop="AREA"
        >
          <span class="c-form__read">
            {{ fd.AREA_NAME }}
          </span>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="24"
      >
        <el-form-item
          class="c-form__item"
          label="公司地址"
          prop="GS_DZ"
        >
          <span class="c-form__read">
            {{ fd.GS_DZ }}
          </span>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="24"
      >
        <el-form-item
          class="c-form__item"
          label="法定代表人"
          prop="FDDBR"
        >
          <span class="c-form__read">
            {{ fd.FDDBR }}
          </span>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="24"
      >
        <el-form-item
          class="c-form__item"
          label="联系人"
          prop="LXR"
        >
          <span class="c-form__read">
            {{ fd.LXR }}
          </span>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="24"
      >
        <el-form-item
          class="c-form__item"
          label="联系电话"
          prop="LXDH"
        >
          <span class="c-form__read">
            {{ fd.LXDH }}
          </span>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="24"
      >
        <el-form-item
          class="c-form__item"
          label="传真"
          prop="CZ"
        >
          <span class="c-form__read">
            {{ fd.CZ }}
          </span>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="24"
      >
        <el-form-item
          class="c-form__item"
          label="邮编"
          prop="YB"
        >
          <span class="c-form__read">
            {{ fd.YB }}
          </span>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="24"
      >
        <el-form-item
          class="c-form__item"
          label="场地面积（m²）"
          prop="CD_MJ"
        >
          <span class="c-form__read">
            {{ fd.CD_MJ }}
          </span>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="24"
      >
        <el-form-item
          class="c-form__item"
          label="法人证件"
          prop="frzjFiles"
        >
          <image-upload-list
            v-if="fd.FRZJ"
            v-model="fd.frzjFiles"
            multiple
            disabled
            list-type="picture-card"
          />
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="24"
      >
        <el-form-item
          class="c-form__item"
          label="营业执照"
          prop="yyzzFiles"
        >
          <image-upload-list
            v-if="fd.YYZZ"
            v-model="fd.yyzzFiles"
            multiple
            disabled
            list-type="picture-card"
          />
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="24"
      >
        <el-form-item
          class="c-form__item"
          label="省平台用户ID"
          prop="PF_USER_ID"
        >
          <span class="c-form__read">
            {{ fd.PF_USER_ID }}
          </span>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="24"
      >
        <el-form-item
          class="c-form__item"
          label="省平台用户密钥"
          prop="PF_PASSWORD"
        >
          <span class="c-form__read">
            {{ fd.PF_PASSWORD }}
          </span>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { deptService } from './dept.service';

export default {
  name: 'AttrViewDept',
  props: {
    deptCode: {
      type: String,
      default: null
    },
    isLoading: {
      type: Boolean
    },
    // 扩展字段列表
    attrDeptList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data () {
    return {
      /* 表单参数 Start */
      fd: {
        parentDeptCode: null,
        parentDeptName: null,
        deptCode: null,
        deptName: null,
        deptShortName: null,
        deptTypeCode: null,
        effectStartDate: null,
        effectEndDate: null,
        source: null,
        TYSHXYDM: null,
        LXR: null,
        LXDH: null,
        CZ: null,
        YB: null,
        YYZZ: [],
        AREA: null,
        AREA_NAME: null,
        GS_DZ: null,
        FDDBR: null,
        CD_MJ: null,
        FRZJ: null,
        frzjFiles: [],
        yyzzFiles: []
      }
      /* 表单参数 End */
    };
  },
  methods: {
    /**
     * @description: 获取组织信息
     * @param {*}
     * @return {*}
     */
    getDeptInfo () {
      const _this = this;
      // 回调页面开启loading状态
      _this.$emit('update:isLoading', true);
      deptService.get(this.deptCode)
        .then(rsp => {
          // 此处修改为不使用Object.assign赋值，
          // 是避免切换组织机构后的扩展字段枚举类的没有值，沿用了上一个组织机构的值
          _this.fd = rsp.data;
          this.$set(_this.fd, 'frzjFiles', rsp.data.FRZJ ? rsp.data.FRZJ.split(';') : []);
          this.$set(_this.fd, 'yyzzFiles', rsp.data.YYZZ ? rsp.data.YYZZ.split(';') : []);
        })
        .catch(err => {
          console.error('获取组织机构数据出错', err);
        })
        .finally(() => {
          // 回调页面开启loading状态
          _this.$emit('update:isLoading', false);
        });
    },
    /**
     * @description: 触发切换页面状态为编辑
     * @param {*}
     * @return {*}
     */
    handleClickSwitchToEdit () {
      this.$emit('switch', 'editDept');
    }
  },
  created () {
    this.getDeptInfo();
  }
};
</script>

<style>
</style>
